module.exports = __webpack_public_path__ + "static/media/profile_white.73b776d3.svg";